import { DefaultConfigState } from './models';
import * as Actions from './actions';
import { createReducer } from '@reduxjs/toolkit';

export const reducer = createReducer (DefaultConfigState, builder => {
    builder.addCase(Actions.ConfigStoreUpdate, (state, action) => {
        return { ...state, ...action.payload }
    });
});